import { render, staticRenderFns } from "./SectionMenu.vue?vue&type=template&id=781907ce&"
import script from "./SectionMenu.vue?vue&type=script&lang=js&"
export * from "./SectionMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('781907ce')) {
      api.createRecord('781907ce', component.options)
    } else {
      api.reload('781907ce', component.options)
    }
    module.hot.accept("./SectionMenu.vue?vue&type=template&id=781907ce&", function () {
      api.rerender('781907ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/albert/albertactionplan/SectionMenu.vue"
export default component.exports